import type { PricingCardProps } from '@/components/home/Pricing/PricingCard';

export const pricingPlans: PricingCardProps[] = [
  {
    title: "Płatność roczna",
    price: "970 zł",
    lowestPrice: "970 zł",
    features: [
      "Natychmiastowy dostęp do wszystkich materiałów",
      "Dodatkowe materiały bonusowe",
      "Priorytetowe wsparcie",
    ],
    buttonText: "Kup teraz",
    isHighlighted: false
  },
  {
    title: "Miesięczne płatności",
    price: "9,7 zł",
    subtitle: "miesięcznie",
    lowestPrice: "9,7 zł",
    regularPrice: "97 zł",
    features: [
      "Natychmiastowy dostęp do wszystkich materiałów",
      "Dodatkowe materiały bonusowe",
      "Wsparcie techniczne"
    ],
    buttonText: "Subskrybuje",
    isHighlighted: true
  }
];